import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddovertimetypepopupComponent } from '../../generalpopup/addovertimetypepopup/addovertimetypepopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import moment from 'moment';

@Component({
  selector: 'app-addovertime',
  templateUrl: './addovertime.component.html',
  styleUrls: ['./addovertime.component.css']
})
export class AddovertimeComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "OVERTIME";

  //Display
  formmode:string="Add";
  rtnform: string = "";
  
   //Mode Values
   isaddmode:boolean=false;
   iseditmode:boolean=false;
   isdeletemode:boolean=false;
   isviewmode:boolean=false;
   isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  
   isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   
  
   isshowattachment: boolean = false;
  attachmentcount: number = 0;

   isshowapproval: boolean = false;
  
   isapprove: boolean = false;
   isreject: boolean = false;
  
   ismanualclose: boolean;
  
   isemploading: boolean=false;

   //Save Validation
   submitted:boolean;
   successfully:boolean;
   saveloading: boolean;
   //Edit Get Values
   overtimeColl:any=[];
   overtimeid:number=0
   overtimeBO: any = {}
  
   overtimetypeColl:any=[];
   empColl:any=[];

  empBO: any = {};

   overtimeform=new FormGroup({
    overtimeid:new FormControl(0),          
    empid:new FormControl(null,Validators.required),
    overtimetypeid:new FormControl(null,Validators.required),  
    transdt:new FormControl(null,Validators.required), 
    othours:new FormControl(null,Validators.required), 
    otrate:new FormControl(''),  
    otamount:new FormControl(''), 
    descr:new FormControl(''),  
    inactive:new FormControl(false),  
   });
  
   dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
      public router: Router,private toastr: ToastrService, private productFindService: NgbModal,private datePipe: DatePipe) { 
        this.route.queryParams.subscribe(params => {
          if(params.id!==undefined){
            this.overtimeid = params.id
          }       
          
          if(params.rtnform!==undefined){
            this.rtnform = params.rtnform
          }  
          
        });
  
        this.fnServiceChanges();

        this.dateCustomClasses = [
          { date: new Date(), classes: ['bg-warning'] },
        ];
  }
  
    
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
  
    });
  }
  
  
  
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
  
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnOnInitForm() {
      try{
          this.isaddmode=true;
          this.overtimeform.reset();
          this.fnInitializeFormGroup(); 
  
          if(this.overtimeid>0){
            this.fngetOvertime();
          }
          this.fngetOvertimeType();
          this.fngetEmployee();

      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.overtimeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
  
    return _check;
  }
  
  fnUserFailedForm() {
    this.isprivilage = true;
  }  
  fnInitializeFormGroup(){
      this.overtimeform.setValue({
        overtimeid:0,
        overtimetypeid:null,             
        empid:null,   
        transdt:new Date(), 
        othours:null, 
        otrate:null, 
        otamount:null, 
        //title:'',
        descr:'',  
        inactive:false              
      })
  }
  
  fngetOvertimeType() {
       
    var data = {
        'overtimeid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getOverTimeType(data)
    .subscribe(
        (res)=>{                  
          if(res.json().status===200){

              this.overtimetypeColl=res.json().result;                    
          }else {

              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{ 
         
            this.toastr.error('Error', err);
    })
  }

  
  fngetEmployee() {
    this.isemploading=true;   

    var data = {
        'empid':0,
        'companyid': this.loginService.fnGetCompanyId(),            
    }
    this.appService.getEmpListView(data)
    .subscribe(
        (res)=>{      
          this.isemploading=false;            
          if(res.json().status===200){
            this.empColl = res.json().result;  
            this.fnChangeEmpLookup();
          }else {
              this.loginService.fnAPIError(res.json())
          }             
        },
        (err)=>{   
          this.isemploading=false;       
            this.toastr.error('Error', err);
    })
  }


  //Get 
  fngetOvertime() {
    if (this.showProgress) {
      return;
    }         
        var data = {
          'overtimeid':this.overtimeid,
          'companyid':this.loginService.fnGetCompanyId()          
        }
        this.appService.fngetOvertime(data)
        .subscribe(
          (res)=>{                
            if(res.json().status===200){  
              this.fnHideProgress();

              this.overtimeColl=res.json().result;
              var editdata = this.overtimeColl[0];   
              this.overtimeBO = editdata;
              this.fnEditMode(editdata);
            }
            else {
              this.fnHideProgress();

              this.loginService.fnAPIError(res.json())
            }
            
        },
        (err)=>{ 
          this.fnHideProgress();
         
          this.toastr.error('Error', err);
        })
  }
  
  fnCalcOvertime()
  {
    var _overtimetypeid=0;
    var _overtimetyperate=0;
    var _overtimetypehour=0;
    
    _overtimetypeid=this.overtimeform.get('overtimetypeid').value;
    _overtimetypehour=this.overtimeform.get('othours').value;

    for(let row of this.overtimetypeColl){
      if(row.overtimetypeid===_overtimetypeid){
        _overtimetyperate=row.rate;
      }
    }


    this.overtimeform.patchValue({otrate:_overtimetyperate})

    this.overtimeform.patchValue({otamount:_overtimetypehour*_overtimetyperate})
    
  }


  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.overtimeform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  
  //Save Btn Click
  fnSaveBtnClick(){
      try{ if (this.saveloading) {
        return;
      }

        this.submitted=true;
        this.successfully=false;
        //Validate
        if(this.overtimeform.valid){ this.saveloading = true;
            //Check
            var data = {
                  'overtimeid': this.overtimeid,  
                  'overtimetypeid':this.overtimeform.get('overtimetypeid').value,
                  'empid':this.overtimeform.get('empid').value,
                  'transdt':this.fnFormatDatetime(this.overtimeform.get('transdt').value), 
                  'otamount':this.overtimeform.get('otamount').value,
                  'otrate':this.overtimeform.get('otrate').value,
                  'othour':this.overtimeform.get('othours').value,
                  'descr':this.overtimeform.get('descr').value,
                  'inactive':this.overtimeform.get('inactive').value,            
                  'companyid':this.loginService.fnGetCompanyId(),
                  'createdby': this.loginService.fnGetModUserId(),  
                 'modifiedby':this.loginService.fnGetModUserId(),                                                              
            }
  
          
         
                      if (this.overtimeform.get('overtimeid').value>0){
                          //Update 
                          this.fnSetOvertime(data);
                        }
                        else{
                          //Insert 
                          this.fnInsertOvertime(data);
                        }
                 
            
         }
      }catch(ex){this.saveloading = false;
        this.fnShowErrorMsg(ex);
      }
  }
  
  
  //Insert
  fnInsertOvertime(data){    
    
      this.appService.fnInsertOvertime(data).subscribe(
        (res)=>{this.saveloading = false;
          if(res.json().status===200){  
            if(res.json().result!=""){
              this.toastr.success('', "The new overtime has been added successfully.Insert Successfully");
              this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
              this.ismanualclose = true;
              this.fnCloseForm();    
              // var _result = res.json().result;

              // if (_result.length > 0) {
              //   var resdata = _result[0];
              //   if (resdata.length > 0) {
              //     this.fnAttachmentSave(resdata[0].overtimeid);
              //   }
              // }
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
      },
        (err)=>{this.saveloading = false;
          this.toastr.error('Error', err);
        });
  
  }
  
  //Set
  fnSetOvertime(data){    
  
  this.appService.fnSetOvertime(data).subscribe(
    (res)=>{this.saveloading = false;
      if(res.json().status===200){  
            if(res.json().result!=""){
                this.toastr.success('', "The overtime has been updated successfully.");
                this.fnInsertActivityLog('EDIT',this.overtimeid,this.fngetDescriptionRefno(data));
                this.ismanualclose = true;
                this.fnCloseForm();        
            } 
        }
      else {
        this.loginService.fnAPIError(res.json())
      }
    },
    (err)=>{this.saveloading = false;
      this.toastr.error('Error', err);
    });
  
  }

  fnEmployeeSearchFn(term: string, item: any) {  
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;       
  }

     //AddMemoType
     private fnAddOvertimeType() {

      const modalRef = this.productFindService.open(AddovertimetypepopupComponent, { size: <any>'l' });
      
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
        this.fngetOvertimeType();
  
        if (receivedEntry > 0) {
            this.overtimeform.patchValue({overtimetypeid:receivedEntry})
        }
      });
  
    }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
       
        this.router.navigate(['/Overtime']);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  private fnEditMode(deptBO){
    deptBO.transdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    //deptBO.adjdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.adjdt));

    this.overtimeform.setValue({ 
      overtimeid:deptBO.overtimeid, 
      overtimetypeid:deptBO.overtimetypeid, 
      empid:deptBO.empid,
      transdt:deptBO.transdt,
      othours:deptBO.othours,
      descr:deptBO.descr,
      otrate:deptBO.otrate,
      otamount:deptBO.otamount,
      inactive:deptBO.inactive
    });
  
    this.formmode="";
      
    this.isaddmode = false;
    this.iseditmode=false;
    this.isdeletemode=false;
    this.isviewmode = true;
    
    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount()
  }
  
  
  //Approvals
  fnApproveBtnClick(type) {

   
    // this.approvebar.formtype = type;    
    // this.approvebar.fnInitializeFormGroup();
    // this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval
    
  }

  fnCloseApproveBtnClick(data) { 
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetOvertime();
    }
    
  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject=false;
   
    if (this.overtimeBO.approvedstatus !== '') {
      if (this.overtimeBO.approvedstatus === 'Approve') {
        this.isreject=true;
      }
      else  if (this.overtimeBO.approvedstatus === 'Reject') {
        this.isapprove=true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject=true;
    }
    
  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  
 //#Attachment
 fnAttachmentBtnClick() {
 
  const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
  modalRef.componentInstance.formname = this.formname;
  modalRef.componentInstance.trxid = this.overtimeid;
  modalRef.componentInstance.formmode = "EDIT";
  modalRef.componentInstance.fnGetAttachment();


  modalRef.result.then(() => {
    this.fnGetAttachmentCount()
  }, () => {
    this.fnGetAttachmentCount()
  })


  modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
    if (receivedEntry === 'DONE') {
      this.fngetOvertime();
    }
    this.fnGetAttachmentCount()
  });

}

  
  
  fnAttachmentSave(tid) {
  
    if (this.attachmentcount > 0) {
      
      this.attachmentbar.formtype = this.formname;    
      this.attachmentbar.trxid = tid;    
      this.attachmentbar.formmode = "ADD";
      
      this.attachmentbar.fnSaveAttachmentByAddMode();
    }
    else {
      this.fnCloseForm();
    }
  
  }
  
  fnSetAttachmentCount(data) {
    
    this.attachmentcount = data;
  }
  
  
  
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  
  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.overtimeid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetOvertime();
      }


    });
  }

  

  //Attachment
  fnGetAttachmentCount() {
    if (this.overtimeid > 0) {
      var data = {
        'trxid': this.overtimeid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }

  
  
  fnFormatDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        return this.datePipe.transform(dt,"yyyy-MM-dd")  
      }
      
      }else {
      return null
    }
    
  }

  fnConvertDatetime(dt){
    if(dt){
      if(dt===""){
        return null
      }
      else{
        var dateParts = dt.split("-");
        var sdate =new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]+1); 
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }
      
      }else {
      return null
    }
   
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }
  fngetDescriptionRefno(data){
    var rtnstr="";
    try{
        if(data.transdt){
          rtnstr=rtnstr+data.transdt;
        }

        if(data.empid){
          rtnstr=rtnstr+" - "+data.empid;
        }

        if(data.empname){
          rtnstr=rtnstr+" - "+data.empname;
        }
      }catch{
      
      }
    return rtnstr;
  }

  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
        logby:this.loginService.fnGetModUserId(),
      }
    
  
      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{
       
        });
  
    }catch{
  
    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }  
  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  


}